import { BUILD_STAMP } from "./buildStamp";
import { trackAppUpdate } from "../analytics/service/analyticsService";
import { withTimeout } from "../../utils/withTimeout";

const RELOAD_GUARD_KEY = "shuttlescore_build_reload_guard";

async function purgeShellCaches() {
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((key) => caches.delete(key)));
  }
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((reg) => reg.unregister()));
  }
}

/**
 * If this tab is running an older bundle than the deployed site, clear SW/cache
 * and reload once (handles stuck shuttlescore-pwa-v1 and similar).
 * @returns {Promise<boolean>} true if a reload was triggered
 */
export async function ensureLatestAppShell() {
  if (process.env.NODE_ENV !== "production") return false;
  if (BUILD_STAMP === "development") return false;

  const base = process.env.PUBLIC_URL || "";
  const versionUrl = `${base}/version.json?_=${Date.now()}`;

  let remoteId;
  try {
    const response = await withTimeout(fetch(versionUrl, { cache: "no-store" }), 3000);
    if (!response.ok) return false;
    const body = await response.json();
    remoteId = body?.buildId;
    if (typeof remoteId !== "string" || !remoteId) return false;
  } catch {
    return false;
  }

  if (remoteId === BUILD_STAMP) return false;

  trackAppUpdate({ update_source: "version_json" });

  try {
    if (sessionStorage.getItem(RELOAD_GUARD_KEY) === remoteId) {
      return false;
    }
    sessionStorage.setItem(RELOAD_GUARD_KEY, remoteId);
  } catch {
    /* sessionStorage */
  }

  try {
    await withTimeout(purgeShellCaches(), 2500);
  } catch {
    /* a stuck cache delete must not block the reload */
  }
  window.location.reload();
  return true;
}
